import { render, staticRenderFns } from "./Praktijkgegevens.vue?vue&type=template&id=f13d36ea&"
import script from "./Praktijkgegevens.vue?vue&type=script&lang=js&"
export * from "./Praktijkgegevens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports